import { RentalObject } from './rental-object';
import { FormOfLease, RentalObjectCategory } from './const/enums';
import { ModelBase } from '../../core/model/model-base';
import { PostTargetModel } from '../service/base/post-target-loader.interface';
import { BrfSpecifics } from './brf-specifics';

export class OtherRentalObject extends RentalObject {
  constructor() {
    super();
    this.category = RentalObjectCategory.Other;
  }

  brfSpecifics: BrfSpecifics;
  condominiumShare: number;
  economicalPlanNumber: string;
  allowedFormsOfLease: FormOfLease[];
  changedAt: Date;
}

export class OtherRentalObjectPostTarget extends ModelBase implements PostTargetModel {
  constructor(dataContext?: OtherRentalObjectPostTarget) {
    super();
    if (dataContext) {
      this.id = dataContext.id || '';
      this.propertyNumberName = dataContext.propertyNumberName || '';
      this.companyNumberName = dataContext.companyNumberName || '';
      this.otherRentalObjectNumberName = dataContext.otherRentalObjectNumberName || '';
    }
  }

  companyNumberName: string;
  propertyNumberName: string;
  otherRentalObjectNumberName: string;

  postTargetDescription() {
    return {
      key: 'POST.POST_TARGET_DESCRIPTION.OTHER_RENTAL_OBJECT',
      params: {
        companyName: this.companyNumberName,
        propertyName: this.propertyNumberName,
        otherRentalObjectName: this.otherRentalObjectNumberName,
      },
    };
  }

  toAutocompleteValue(viewType: 'list' | 'field', culture?: string): string {
    switch (viewType) {
      case 'field':
      case 'list':
        return this.otherRentalObjectNumberName;
    }
  }

  toString(culture?: string): string {
    return this.otherRentalObjectNumberName;
  }
}
